import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLElement> {
  expand(event: Event): void {
    event.preventDefault()
    this.element.classList.add(
      'comment-expandable-list-expanded',
      'comment-expandable-list-no-expand'
    )
  }
}
